/* eslint-disable */
import {
  CLEAR_AUTH_ERROR,
  CONFIRM_USER_REGISTRATION_FAIL,
  CONFIRM_USER_REGISTRATION_START,
  CONFIRM_USER_REGISTRATION_SUCCESS,
  MOBILE_USER_LOGIN_FAIL,
  MOBILE_USER_LOGIN_START,
  MOBILE_USER_LOGIN_SUCCESS,
  MOBILE_USER_REGISTRATION_FAIL,
  MOBILE_USER_REGISTRATION_START,
  MOBILE_USER_REGISTRATION_SUCCESS,
  RESTORE_MOBILE_FAIL,
  RESTORE_MOBILE_START,
  RESTORE_MOBILE_SUCCESS,
} from './constants';

import { API_URL_MOBILE } from '@shared/constants/config';
import { POST, REST_API } from '@shared/constants/rest-api';

const headers = {
  Accept: '*/*',
  'Content-Type': 'application/json',
};

const defaultToken = '';

export const mobileUserLogin = (body, onSuccess, onError) => ({
  type: REST_API,
  method: POST,
  url: `${API_URL_MOBILE}/login`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  body,
  onSuccess,
  onError,
  types: [MOBILE_USER_LOGIN_START, MOBILE_USER_LOGIN_SUCCESS, MOBILE_USER_LOGIN_FAIL],
});

export const registrUserLogin = (body, onSuccess, onError) => ({
  type: REST_API,
  method: POST,
  url: `${API_URL_MOBILE}/register`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  body,
  types: [MOBILE_USER_REGISTRATION_START, MOBILE_USER_REGISTRATION_SUCCESS, MOBILE_USER_REGISTRATION_FAIL],
  onSuccess,
  onError,
});

export const confirmRegistrUserLogin = (body, onSuccess, onError) => ({
  type: REST_API,
  method: POST,
  url: `${API_URL_MOBILE}/confirm`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  body,
  types: [CONFIRM_USER_REGISTRATION_START, CONFIRM_USER_REGISTRATION_SUCCESS, CONFIRM_USER_REGISTRATION_FAIL],
  onSuccess,
  onError,
});

export const restoreMobileUser = (param, onSuccess, onError) => ({
  type: REST_API,
  method: POST,
  url: `${API_URL_MOBILE}/restore`,
  headers,
  body: param,
  onSuccess,
  onError,
  types: [RESTORE_MOBILE_START, RESTORE_MOBILE_SUCCESS, RESTORE_MOBILE_FAIL],
});

export const clearError = () => ({
  type: CLEAR_AUTH_ERROR,
});
